import React from 'react';
import { classNames } from 'tradera/utils/class-names';
import styles from './item-card-image.module.scss';
import type { SrcSetMap } from './item-card-image-size';
import { getSrc } from './item-card-image-size';

type SecondaryImageProps = {
    imageSecondaryUrl?: string;
    srcSetMap?: SrcSetMap;
};

export const SecondaryImage = ({
    imageSecondaryUrl,
    srcSetMap
}: SecondaryImageProps) => {
    if (!imageSecondaryUrl) {
        return null;
    }

    const imageUrl = getSrc(imageSecondaryUrl, 'medium', srcSetMap?.['1x']);

    return (
        <div
            className={classNames(
                styles.fillAspectRatio,
                styles.secondaryImage
            )}
            style={{
                backgroundImage: `url(${imageUrl})`
            }}
        />
    );
};
